import styled from 'styled-components';
import { List } from 'antd';
const Container = styled(List)`

`

export {
  Container
}
